module.exports = __webpack_public_path__ + "img/p1.0751a2a7.jpg";